import Icon from 'veui/components/Icon'
import { IconClock } from 'dls-icons-vue'

Icon.register('clock', IconClock)
